import { __assign } from 'tslib';
import { styled } from '@mui/material/styles';

var PREFIX = "PDFViewer";
var classes = {
    document: "".concat(PREFIX, "-document"),
    toolbar: "".concat(PREFIX, "-toolbar"),
    toolbarRight: "".concat(PREFIX, "-toolbarRight"),
    page: "".concat(PREFIX, "-page"),
    loading: "".concat(PREFIX, "-loading"),
    previewImg: "".concat(PREFIX, "-previewImg"),
    previewSkeleton: "".concat(PREFIX, "-previewSkeleton"),
    progress: "".concat(PREFIX, "-progress"),
    pageControls: "".concat(PREFIX, "-pageControls"),
    pagination: "".concat(PREFIX, "-pagination")
};
var StyledPDFViewer = styled("div", {
    shouldForwardProp: function (prop) { return prop !== "fullscreen"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, fullscreen = _a.fullscreen;
    return (__assign(__assign({ display: "flex", flexDirection: "column", alignItems: "center", position: "relative", maxWidth: "100%" }, (fullscreen && {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "auto",
        zIndex: theme.zIndex.drawer + 1,
        background: theme.palette.background.paper
    })), (_b = {}, _b["& .".concat(classes.document)] = {
        flexGrow: 1,
        height: "100%",
        width: "100%",
        textAlign: "center"
    }, _b["& .".concat(classes.toolbar)] = {
        background: theme.palette.grey[100],
        padding: theme.spacing(0.5, 1),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(1)
    }, _b["& .".concat(classes.toolbarRight)] = {
        display: "flex",
        gap: theme.spacing(1)
    }, _b["& .".concat(classes.page)] = {
        /* Disable the document copy by right click */
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "100%",
        ".annotationLayer section": {
            position: "absolute",
            textAlign: "initial"
        }
    }, _b["& .".concat(classes.loading)] = {
        position: "relative",
        height: "100%"
    }, _b["& .".concat(classes.previewImg)] = {
        height: "100%",
        width: "100%",
        objectFit: "contain"
    }, _b["& .".concat(classes.previewSkeleton)] = {
        height: "100%",
        width: "100%"
    }, _b["& .".concat(classes.progress)] = {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0
    }, _b["& .".concat(classes.pageControls)] = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(1),
        width: "100%",
        padding: theme.spacing(1),
        flexDirection: "column"
    }, _b["& .".concat(classes.pagination)] = { padding: theme.spacing(1) }, _b)));
});

export { classes, StyledPDFViewer as default };
//# sourceMappingURL=index.styled.js.map
